import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from './Shared';
export function Guarantee() {
  return <Section className="max-w-3xl" data-id="element-95" data-mp="3gg11ma61ua0t">
      <div className="glass-panel rounded-3xl border-brand-forest/30 p-8 text-center md:p-12" data-id="element-96" data-mp="3gh3qkcjta2e3">
        <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-forest" data-id="element-97" data-mp="32lrn9grlb3lk" />
        <h2 className="mt-5 font-display text-3xl font-bold text-brand-ink" data-id="element-98" data-mp="36pza18ehm9h5">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>
        <p className="mt-5 text-brand-text" data-id="element-99" data-mp="3ud7ifz77pyne">
          Abrís el Botiquín. Aplicás las fichas. Lo usás en tu consultorio o en
          casa.
        </p>
        <p className="mt-4 text-brand-text" data-id="element-100" data-mp="3ldkd52bd48p2">
          Si en 7 días no es exactamente lo que esperabas: devolución del 100%
          sin formularios, sin drama, sin preguntas.
        </p>
        <p className="mt-6 font-semibold text-brand-forest" data-id="element-101" data-mp="29y5i442prqwl">
          Tasa de devoluciones: menos del 1%.
        </p>
      </div>
    </Section>;
}
export function Footer() {
  return <footer className="border-t border-brand-gold/35 bg-brand-ink py-12 text-brand-paper" data-id="element-102" data-mp="3l90ozzfy550u">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-103" data-mp="3gaz376r4yrlo">
        <h3 className="font-display text-3xl font-bold text-brand-goldLight" data-id="element-104" data-mp="3gctmyhqo8do6">
          LUMEN AKASHA™
        </h3>
        <p className="mx-auto mt-3 max-w-2xl text-white/80" data-id="element-105" data-mp="3q8wp3nliwcb4">
          La herramienta clínica N°1 de digitopuntura para terapeutas en
          Argentina.
        </p>
        <p className="mx-auto mt-2 max-w-2xl text-white/70" data-id="element-106" data-mp="80xk4905f1jm">
          Porque aplicar Medicina Tradicional China con excelencia no debería
          costarte la seguridad ni la eficacia de tu consultorio.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 text-sm text-brand-goldLight sm:flex-row sm:gap-7" data-id="element-107" data-mp="ctqouwvma9vp">
          <a className="transition-colors hover:text-brand-paper" href="mailto:soportelumenakasha@gmail.com" data-id="element-108" data-mp="qsqdw5n1kqse">
            soportelumenakasha@gmail.com
          </a>
          <a className="transition-colors hover:text-brand-paper" href="https://instagram.com/lumen.akasha" data-id="element-109" data-mp="tvw6kdlnj9ee">
            @lumen.akasha
          </a>
          <a className="transition-colors hover:text-brand-paper" href="https://www.lumenakasha.com" data-id="element-110" data-mp="13tkb1v927v9r">
            www.lumenakasha.com
          </a>
        </div>
        <div className="mt-10 space-y-2 text-xs text-white/50" data-id="element-111" data-mp="1clunlj7fgcu6">
          <p data-id="element-112" data-mp="1cnozy94muwmn">
            © Lumen Akasha™ 2026 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
          <p data-id="element-113" data-mp="1ml3eu4awrdcu">
            Ley 25.326 — Protección de Datos Personales — República Argentina
          </p>
        </div>
        <p className="mt-8 font-serif text-sm italic text-brand-goldLight/75" data-id="element-114" data-mp="1ri3kie3uie3f">
          “El terapeuta que tiene un sistema aplica con confianza. El que aplica
          con confianza genera resultados. El que genera resultados crece.”
        </p>
      </div>
    </footer>;
}